import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancelToken = null;

class UserPreferencesService {
  getUserPreferences() {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.get(`${Config.api.tender.url}user-preferences`, {
      cancelToken: cancelToken.token,
    }).then((response) => response.data);
  }
  updateUserPreferences(userPreferences) {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.post(`${Config.api.tender.url}user-preferences`, userPreferences, {
      cancelToken: cancelToken.token,
    }).then((response) => response.data);
  }
}

export const userPreferencesService = new UserPreferencesService();
